<template>
  <div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12">
    <div class="form-group row">
      <label class="col-form-label col-sm-4" for="">{{ t('selectYearLabel', 'selectYearLabel') }}</label>
      <div class="col-sm-8">
        <select name="durationInMonth" @change="fillData()" class="form-control" v-model="conversionsYear">
          <!--<option v-if="clientName != 'gskp' && clientName != 'gskptest' && clientName != 'kmps' && clientName != 'kmpstest'" value="2014">2014</option>
          <option v-if="clientName != 'gskp' && clientName != 'gskptest' && clientName != 'kmps' && clientName != 'kmpstest'" value="2015">2015</option>
          <option v-if="clientName != 'gskp' && clientName != 'gskptest' && clientName != 'kmps' && clientName != 'kmpstest'" value="2016">2016</option>
          <option v-if="clientName != 'gskp' && clientName != 'gskptest' && clientName != 'kmps' && clientName != 'kmpstest'" value="2017">2017</option>
          <option v-if="clientName != 'gskp' && clientName != 'gskptest' && clientName != 'kmps' && clientName != 'kmpstest'" value="2018">2018</option>
          <option v-if="clientName != 'gskp' && clientName != 'gskptest' && clientName != 'kmps' && clientName != 'kmpstest'" value="2019">2019</option>
          <option v-if="clientName != 'gskp' && clientName != 'gskptest' && clientName != 'kmps' && clientName != 'kmpstest'" value="2020">2020</option>
          <option value="2021">2021</option> -->
          <option v-for="option in options" :value="option" :key="option">{{ option }}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="col-12 relative-position">
    <loading
      id="widget-loading-spinner"
      class="align-items-center"
      :color="'#047bf8'"
      :loader="'spinner'"
      :active="isLoading"
      :transition="'fade'"
      :is-full-page="false">
    </loading>
    <line-chart :download="true" :data="dataCollection" :messages="{ empty: t('noDataAvailable', 'noDataAvailable')}"></line-chart>
  </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import { clientShortName } from '@/helpers/clientShortName.js'

export default {
  name: 'ElectronicConversionsChart',
  data(){
    return{
      conversionsYear: 2021,
      dataCollection:[],
      isLoading: true,
      options: null
    }
  },
  components: {
    Loading
  },
  created(){
      this.fillData()
  },
  methods: {
    fillData(){
      this.isLoading = true
      this.$store.dispatch("widgetsStore/getElectronicConversions", {conversionsYear: this.conversionsYear}).then(response => {
        this.dataCollection = new Array()
        if(response.conversions) {
          this.dataCollection = response.conversions
        }

        if(response.options) {
          this.options = response.options
        }

        this.isLoading = false
      })
    }
  },
  computed: {
    clientName() {
      let clientName = clientShortName()
      return clientName
    },
  }
}
</script>

<style scoped>
  .relative-position {
    position: relative;
  }
</style>